import React from 'react';
import './AlertsPanel.css';
import './ConsistencyPanel.css';

/**
 * ConsistencyPanel — sinais SOFT de consistência da análise (C-A/C-B, Sessão 41).
 *
 * Orientações de MÉTODO para o analista revisar — distintas das "Validações
 * Automáticas" (que falam de completude de dados / score). Estes sinais NÃO
 * afetam a nota; o subtítulo deixa isso explícito (coerência com o C-PRE).
 *
 * Fonte: campo `avisos_consistencia` da resposta da NC (backend só popula em
 * modo Investigação; Registro vem vazio). Lista vazia/ausente → não renderiza
 * nada (sem card). Reaproveita a estilização de AlertsPanel (.alert-item etc).
 */
function ConsistencyPanel({ avisos }) {
  if (!Array.isArray(avisos) || avisos.length === 0) return null;

  // Espelha o normalize de severidade do AlertsPanel ('média' → 'media').
  const sevOf = (a) => {
    const raw = (a?.severidade || '').toString().trim().toLowerCase();
    return raw === 'média' ? 'media' : raw;
  };

  return (
    <div className="alerts-panel consistency-panel">
      <div className="alerts-header">
        <h4>Consistência da análise</h4>
        <span className="alerts-count">{avisos.length}</span>
      </div>
      <p className="consistency-sub">
        Pontos de método para revisar antes de fechar — não afetam a nota.
      </p>
      {avisos.map((a, idx) => (
        <div key={idx} className={`alert-item ${sevOf(a) || 'media'}`}>
          <span className="alert-dot" />
          <span className="alert-mensagem">{a?.mensagem}</span>
        </div>
      ))}
    </div>
  );
}

export default ConsistencyPanel;
